import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "BigTitleArea NormalPaddings" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "BigTitleTextArea" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "Header" }, "Enkelin Esiliina"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "Footer NormalPaddings" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Copyright © Enkelin Esiliina")
], -1)

import Navigation from "./components/Navigation.vue";
import Wisdom from "./components/Wisdom.vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Navigation),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(Wisdom)
    ]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _unref(route).fullPath
    })),
    _hoisted_4
  ]))
}
}

})